<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <base-input alternative="" label="Select Site">
                                <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'" @change="getterminals">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                        <div class="col-md-6">
                            <base-input alternative="" label="Select Payment Type">
                                <a-select mode="multiple" v-model="inputPaymentType" showSearch placeholder="All Payment Type" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                    <a-select-option v-for="option in paymentTypeOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <base-input alternative="" label="Date Range"><br>
                                <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM/DD/YYYY hh:mm A" :placeholder="['Start Time', 'End Time']" style="width:100%"/>
                            </base-input>
                        </div>
                        <div class="col-md-6">
                            <base-input label="Terminal">
                                <a-select style="width: 100%" mode="multiple" showSearch placeholder="All Terminals" optionFilterProp="children"  v-model="selectedTerminalId">
                                    <a-select-option v-for="terminal in filteredValidTerminals" :key="terminal.id" :value="terminal.id">{{terminal.name}} ({{terminal.code}})</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <base-input label="Cashier">
                                <a-select style="width: 100%" placeholder="Please select cashier" optionFilterProp="children"  v-model="selectedCashierId">
                                    <a-select-option value="0">All Cashiers</a-select-option>
                                    <a-select-option v-for="cashier in validCashiers" :key="cashier.id" :value="cashier.id">{{cashier.first_name}} {{cashier.last_name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <download-excel
                                worksheet="Sales Reports"
                                :name="excelFileName"
                                type="xlsx"
                                :fetch="excelData"
                                :fields="excelHeaders">
                                <button class="btn btn-sm btn-success float-right ml-2"
                                        style="border-radius: 24px; border:0px; width: 20%;">
                                  Generate Report in Excel
                                </button>
                            </download-excel>

                            <button class="btn btn-sm btn-default float-right"
                                    style="border-radius: 24px; border:0px; width: 20%;"
                                    @click.prevent="generateReport">
                              Generate Report in PDF
                            </button> &nbsp; &nbsp;
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import reportUtils from '../../components/reportUtils'
    import { getReportDescription } from '../../utilities';


    function formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    import {
        mapState
    } from 'vuex'
import { PaperSize } from 'exceljs';

    export default {
        data() {
          return {
            spinning: false,
            inputDate: [moment().startOf('day'), moment().endOf('day')],
            groupOptions: [
              {key: 'site_id', value: 'Site'},
              {key: 'payment_type_id', value: 'Payment Type'},
              {key: 'user_id', value: 'Cashier'},
              {key: 'terminal_id', value: 'Terminal'}
            ],
            inputPaymentType: [],
            paymentTypeOptions: [],
            isShowReservation: false,
            isShowBalStatus: false,
            isShowWithdraw: false,
            inputSite: [],
            site_type: "ho",
            siteOptions: [],
            birPosTenderReports: [],
            excelFileName: `POS_Collections_Report_${moment().format('YYYY_MM_DD_HH_mm_ss')}`,
            excelHeaders: {},
            selectedTerminalId: [],
            validTerminals: null,
            filteredValidTerminals: null,
            selectedCashierId: "0",
            validCashiers: null,
            reportDescription: ''
          }
        },
        watch: {
            isShowBalStatus: function() {
                if(this.isShowBalStatus == true){
                    this.isShowReservation = false;
                } else {
                    this.isShowWithdraw = false;
                }
            },
            isShowWithdraw: function() {
                if(this.isShowWithdraw == true){
                    this.isShowBalStatus = true;
                    this.isShowReservation = false;
                }
            },
            isShowReservation: function() {
                if(this.isShowReservation == true){
                    this.isShowBalStatus = false;
                    this.isShowWithdraw = false;
                }
            }
        },
        mounted: async function () {
            var component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]
            this.reportDescription = await getReportDescription(this.currentProfile)

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }

            var terminal_data = await HTTPRequest.getRequest(this.endPoint + 'terminals/get_valid_terminals', null)
            this.validTerminals = terminal_data  
            this.filteredValidTerminals = terminal_data  

            var cashier_data = await HTTPRequest.getRequest(this.endPoint + 'users/get_valid_cashiers', null)
            this.validCashiers = cashier_data

            var payment_types = await HTTPRequest.getRequest(component_x.endPoint + "payment_types/get_valid_payment_types", null);
            component_x.paymentTypeOptions = payment_types;

            component_x.sort(component_x.paymentTypeOptions)
            console.log(component_x.paymentTypeOptions)

            this.getterminals()
            // component_x.inputPaymentType = [component_x.paymentTypeOptions[0].id]
        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        methods: {
            async getterminals () {
                this.selectedTerminalId = []
                this.filteredValidTerminals = []
                this.validTerminals.map(item => {
                    if(this.inputSite.includes(item['site_id'])){
                        this.filteredValidTerminals.push(item)
                    }
                })

                if(this.inputSite == ''){
                    this.filteredValidTerminals = this.validTerminals
                }
            },
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            openNotificationWithIcon(type, msg) {
                if(type == 'error'){
                    this.$notification[type]({
                        message: 'Export Error',
                        description: msg
                    });
                }else if(type == 'warning'){
                    this.$notification[type]({
                        message: 'No Data Found',
                        description: msg
                    });
                }
            },
            async exportRequest() {
              this.spinning= true;
              let request = {};
              let errorMsg = "";

              if(this.selectedTerminalId == '' || this.selectedTerminalId == null){
                   const ids = this.filteredValidTerminals.map(filteredValidTerminal => filteredValidTerminal.id);
                   this.selectedTerminalId = ids
              }

            //   if(this.inputPaymentType.length > 10){
            //     // alert('Number of selected payment types exceeded. Maximum should be 10.');
            //     errorMsg = 'Number of selected payment types exceeded. Maximum should be 10.';
            //   } else 
            //   if(this.inputPaymentType.length == 0){
            //     // alert('Please select at least one payment type.')
            //     errorMsg = 'Please select at least one payment type.';
            //   }else 
              if(this.selectedTerminalId == '' || this.selectedTerminalId == null){
                    errorMsg = 'Please select terminal.';
              } else {
                let payment_types = []
                payment_types.push(...this.inputPaymentType)

                if(this.inputDate.length == 0){
                  // this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                  errorMsg = 'Please make sure to check your current filters.';
                  this.spinning= false;
                  return { request, errorMsg };
                }

                request = await HTTPRequest.getRequest(this.endPoint + 'pos_documents/pos_tender?site_id=' + this.inputSite +
                '&date_from=' + this.inputDate[0].format('YYYY-MM-DD HH:ss:mm') + '&date_to=' + this.inputDate[1].format('YYYY-MM-DD HH:ss:mm') +
                '&payment_type_id=' + payment_types + '&user_id=' + this.selectedCashierId +
                '&terminal_id=' + this.selectedTerminalId, null)

                if(request.error) {
                  errorMsg = request.error;
                  // this.openNotificationWithIcon('error', request.error);
                }
              }
             this.spinning= false;
              return { request, errorMsg }
            },
            async excelData() {
              const { request, errorMsg } = await this.exportRequest();

              if (errorMsg.length > 0) {
                this.openNotificationWithIcon('error', errorMsg);
                  return;
              }

              const siteSpecificRequest = request;

              if (siteSpecificRequest.length < 1) {
                this.openNotificationWithIcon('warning', 'Try increasing the scope by adjusting the filters.');
                return
              }

              let jsonData = [];
              this.excelFileName = `POS_tender_Report_${moment().format('YYYY_MM_DD_HH_mm_ss')}`;

                this.excelHeaders = {
                  "Date": "date",
                  "TransID": "TransId",
                  "SI#": "invoiceNo",
                  "Tender Type": "tenderType",
                  "Tender Details": "tenderDetails",
                  "Bank Name": "bankName",
                  "Bank Card Term":"bankCardTermName",
                  "Amount": "amount",
                  "Tender": "tender",
                  "Cashier": "cashierName",
                  "Branch": "siteName",
                }

                siteSpecificRequest.map(siteData => {
                  const reportDetails = siteData.report_details;
                  if (reportDetails) {
                    reportDetails.map(detail => {

                      let detailObj = {
                        date:  moment(detail.created_at).format('MM/DD/YYYY'),
                        TransId: detail.trans_id,
                        invoiceNo: detail.invoice_no,
                        tenderType: detail.tender_type,
                        tenderDetails: detail.tender_details,
                        bankName: detail.bank_name,
                        bankCardTermName:detail.bank_card_term_name,
                        amount:detail.amount,
                        tender:detail.tender,
                        cashierName: detail.cashier_name,
                        siteName: detail.site_name,
                      }

                      jsonData.push(detailObj)
                    })
                  }
                })

              return jsonData;
            },
            generateReport: async function () {
                this.spinning= true;
                const { request, errorMsg } = await this.exportRequest();

                if (errorMsg.length > 0) {
                  this.openNotificationWithIcon('error', errorMsg);
                  return;
                }

                var siteSpecific = request;

                if (siteSpecific.length < 1) {
                  this.openNotificationWithIcon('warning', 'Try increasing the scope by adjusting the filters.');
                  this.spinning= false;
                  return;
                }

                let paperSize = 'legal' 
                if(this.selectedTerminalId.length > 1){
                    paperSize = 'tabloid'
                }

                let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: paperSize});
                try {
                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);
                } catch (error) {
                    
                }

                let headers = [
                        [
                            {content: 'Date', styles: {halign: 'center'}},
                            {content: 'Trans ID', styles: {halign: 'center'}},
                            {content: 'SI #', styles: {halign: 'center'}},
                            {content: 'Tender Type', styles: {halign: 'center'}},
                            {content: 'Tender Details', styles: {halign: 'center'}},
                            {content: 'Bank Name', styles: {halign: 'center'}},
                            {content: 'Amount', styles: {halign: 'center'}},
                            {content: 'Tender', styles: {halign: 'center'}},
                            {content: 'Cashier', styles: {halign: 'center'}},
                            {content: 'Branch', styles: {halign: 'center'}}
                        ]
                ];

                if(this.selectedTerminalId.length > 1){
                    headers[0].push({content: 'Terminal', styles: {halign: 'center'}})
                }

                for(var x=0; x < siteSpecific.length; x++){
                        this.birPosTenderReports = siteSpecific[x].report_details

                        if(x > 0 && this.birPosTenderReports.length > 0){
                            doc.addPage();
                        }

                        let total_amount = 0
                        let grand_total_amount = 0

                        let total_tender = 0
                        let grand_total_tender = 0

                        // grouping
                        let reportData = [];
                        let grouper = 'start'
                        let type_header = 'start'

                        if(this.birPosTenderReports.length > 0){
                            let arr = 'start'
                            for(var i=0; i < this.birPosTenderReports.length; i++){
                                let reportLine = this.birPosTenderReports[i]

                                // grouping
                                let grouper_name = reportLine.tender_type

                                if(grouper == 'start'){
                                    let detail_header = [{content: grouper_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}];
                                    reportData.push(Object.assign({}, detail_header))
                                } else {
                                    if(grouper != reportLine.tender_type){
                                        let detail_header = [{content: grouper_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                }
                                grouper = reportLine.tender_type

                                let detail = []
                                
                                detail = [
                                    moment(reportLine.created_at).format('MM/DD/YYYY hh:mm a'),
                                    reportLine.trans_id,
                                    reportLine.invoice_no,
                                    reportLine.tender_type,
                                    reportLine.tender_details,
                                    reportLine.bank_name,
                                    reportLine.amount,
                                    reportLine.tender,
                                    reportLine.cashier_name,
                                    reportLine.site_name,
                                ]

                                if (this.selectedTerminalId.length > 1){
                                    detail.push(reportLine.terminal_name)
                                }
                                
                                reportData.push(Object.assign({}, detail))

                                total_amount += Number(reportLine.amount)
                                grand_total_amount += Number(reportLine.amount)

                                total_tender += Number(reportLine.tender)
                                grand_total_tender += Number(reportLine.tender)

                                if(i == this.birPosTenderReports.length - 1){
                                   
                                    let sub_detail = []
                                    let spacer = grouper_name
                                
                                    sub_detail = ["", "", "", "",
                                    {content: spacer, styles: {halign: 'right', fontStyle: 'bold'}}, "", this.convertToCurrency(total_amount), 
                                    this.convertToCurrency(total_tender), '', '', '']
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, sub_detail))
                                    
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, ['', '', '', '', 'Grand Total :', '', this.convertToCurrency(grand_total_amount), 
                                    this.convertToCurrency(grand_total_tender), '', ''
                                    ]));
                                        
                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""
                                    current_grouper = reportLine.tender_type
                                    next_grouper = this.birPosTenderReports[i+1].tender_type

                                    if(current_grouper != next_grouper){
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        let sub_detail = []

                                        let spacer = grouper_name

                                        sub_detail = ["", "", "", "",
                                            {content: spacer, styles: {halign: 'right', fontStyle: 'bold'}}, "", this.convertToCurrency(total_amount), 
                                            this.convertToCurrency(total_tender), '', '']

                                        reportData.push(Object.assign({}, sub_detail))

                                        total_amount = 0
                                        total_tender = 0
                                    }
                                    
                                }
                            }
                            let colStyles = {
                                0: {cellWidth: 35},
                                1: {cellWidth: 20},
                                2: {cellWidth: 20},
                                3: {cellWidth: 30},
                                4: {cellWidth: 75},
                                5: {cellWidth: 30},
                                6: {cellWidth: 30},
                                7: {cellWidth: 30},
                                8: {cellWidth: 30},
                                9: {cellWidth: 30},
                            }

                            let design_x = 525
                            let design_y = 225

                            if(this.selectedTerminalId.length > 1){
                                colStyles = {
                                    0: {cellWidth: 35},
                                    1: {cellWidth: 20},
                                    2: {cellWidth: 20},
                                    3: {cellWidth: 30},
                                    4: {cellWidth: 95},
                                    5: {cellWidth: 30},
                                    6: {cellWidth: 30},
                                    7: {cellWidth: 30},
                                    8: {cellWidth: 30},
                                    9: {cellWidth: 30},
                                    10: {cellWidth: 50},
                                }

                                design_x = 525
                                design_y = 270
                            }

                            doc.setFontSize(14);
                            doc.setFontType("bold");

                            doc.text(15,20,"POS Tender Report")
                            doc.setFontType("normal");
                            doc.setFontSize(10);
                            
                            doc.text(340,20,siteSpecific[x].report_details[0].site_name, "right")
                            doc.text(15,25,"As of " + this.inputDate[0].format('MMMM DD, YYYY hh:mm A')  + " to " + this.inputDate[1].format('MMMM DD, YYYY hh:mm A'))

                            doc.autoTable({
                                startY: 30, 
                                head: headers, 
                                body: reportData, 
                                theme: 'plain',
                                tableWidth: 'wrap',
                                headStyles: {
                                    lineWidth: 0.15,
                                    cellPadding: 2
                                },
                                styles: {
                                    cellPadding: 1.0, fontSize: 9,
                                    halign: 'right'
                                },
                                columnStyles: colStyles,
                                didParseCell: function(data) {
                                    if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                        data.cell.styles.fillColor = [0, 0, 0]
                                        data.cell.styles.fontSize = 1
                                        data.cell.styles.cellPadding = 0
                                    } else if (data.row.section == 'body' && (data.row.raw[5] == 'Total :' && data.row.raw[5] == 'Grand Total :')){
                                        data.cell.styles.fontStyle = 'bold'
                                    }
                                }
                            });

                            // doc.text(15,205,"Printed By: " + secureStorage.getItem("email"))
                            // doc.text(340,205,"POS Tender Report", "right")
                            // doc.text(15,210,"Print Date: " + moment().format("MM/DD/YYYY h:mm:ssA"))
                            // doc.text(340,210,"Page " + ( x + 1)  + " of " + siteSpecific.length, "right")
                            let pageCount = doc.internal.getNumberOfPages();
                            let printed_by = secureStorage.getItem("email")
                            let group_text = "Tender Type"
                            if(printed_by == null){
                                printed_by = ''
                            }

                            for(let i = 1; i <= pageCount; i++) {
                                doc.setPage(i);
                                reportUtils.pdfTools.addFooter(doc, printed_by, "POS Tender Report" + group_text, design_x, design_y, i, pageCount)
                            }
                        }
                }

                    window.open(URL.createObjectURL(doc.output("blob")))
            }
        }
    };
</script>

<style></style>
